( function( $, document, window ) {
    'use strict';

    $( function() {
		const $link = $( '.js-modal-video' );

	    document.addEventListener( 'cmplz_status_change', function ( e ) {
		    if ( e.detail.category === 'marketing' && e.detail.value === 'allow' ) {
			    $link.attr( 'data-fancybox', '' );
		    }
	    });
    } );
} )( jQuery, document, window );
